module.exports = __webpack_public_path__ + "img/cu.b9ca1bb2.svg";